export enum IdentityProvider {
  Default = 0,
  SwedishBankID = 1,
}